'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useLocale } from '@src/i18n/LocaleProvider';
import { downloadFile } from '@src/utils/downloadFile.util';
export function BadgeShareSection(t0) {
  const $ = _c(15);
  const {
    socialShare
  } = t0;
  const {
    t
  } = useLocale("badge-detail");
  let t1;
  if ($[0] !== socialShare) {
    t1 = async () => {
      if (!socialShare) {
        return;
      }
      const fileName = new URL(socialShare, window.location.href).pathname.split("/").pop() ?? "badge.jpg";
      await downloadFile({
        url: socialShare,
        fileName
      });
    };
    $[0] = socialShare;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSaveImage = t1;
  if (!socialShare) {
    return null;
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("save-image");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image src="/images/save-image.svg" alt="" width={32} height={32} className="size-8" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== handleSaveImage || $[6] !== t2) {
    t4 = <button type="button" onClick={handleSaveImage} className="flex size-[60px] cursor-pointer items-center justify-center rounded-full border border-white/50 bg-white/5 p-0 transition-colors hover:bg-white/10" aria-label={t2}>{t3}</button>;
    $[5] = handleSaveImage;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t("save-image");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="text-body-xs text-bodi-white">{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <div className="flex flex-col items-center gap-1">{t4}{t6}</div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}